import { render, staticRenderFns } from "./PaginationLinks.vue?vue&type=template&id=8768daa4&scoped=true"
import script from "./PaginationLinks.vue?vue&type=script&lang=js"
export * from "./PaginationLinks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8768daa4",
  null
  
)

export default component.exports